module.exports = __webpack_public_path__ + "e7acac5c1a0296531f43f4cba698cc33.pdf";